export enum ReliabilityReportType {
  FailOnFit = 1,
  PrematureFailure = 2,
  RogueCandidate = 3,
  ThyFailOnFit = 4,
  ThyPrematureFailure = 5,
}

export const ReliabilityReportTypeChoices = [
  { key: "Fail On Fit", value: ReliabilityReportType.FailOnFit },
  { key: "Premature Failure", value: ReliabilityReportType.PrematureFailure },
  { key: "Rogue Candidate", value: ReliabilityReportType.RogueCandidate },
  { key: "Thy Fail On Fit", value: ReliabilityReportType.ThyFailOnFit },
  { key: "Thy Premature Failure", value: ReliabilityReportType.ThyPrematureFailure },
];
